import '../estilo/blog-libros.scss'
import * as comun from './modulos/comun'
import * as buscador from './widgets/buscador'
import articulus from './modulos/articulus'

comun.registrarServiceWorker().catch(error => { console.error(error) })
comun.chorrear(() => {
  comun.iniciarMenu('mnuBlog')
})
const isoIdioma = comun.obtenerIdiomaUrl()
comun.setIdiomaPagina()
buscador.iniciar()

const arti2cat = {
  'abuelo': 'los_consejos_de_mi_abuelo_facho',
  'infarto': 'el_mejor_infarto_de_mi_vida',
  'messi': 'messi_es_un_perro_y_otros_cuentos',
  'paraiso': 'el_nuevo_paraiso_de_los_tontos',
  'alpiste': 'espana_deci_alpiste',
  'respeto': 'mas_respeto_que_soy_tu_madre',
  'el_pibe': 'el_pibe_que_arruinaba_las_fotos',
  'charlas': 'charlas_con_mi_hemisferio_derecho'
}

let url = `${comun.urlBaseApi}/apis/articulus/v1/blogs/libros_${isoIdioma}/articulos/?orden=crono&ordenDir=desc&pag=1&porPag=20&categoria=libro_del_blog`
listarLibros(url, document.querySelector('.plantilla.libro'), document.querySelector('.libros'))

function listarLibros (urlApi, plantilla, contenedor) {
  articulus(urlApi, isoIdioma).then(artis => {
    mostrarArticulos(artis)
  }).catch(error => { console.log(error) })

  function mostrarArticulos (artis) {
    if (artis.articulos.length > 0) {
      artis.articulos.forEach(arti => {
        const item = plantilla.cloneNode(true) // Clona plantilla
        item.querySelector('.titulo').textContent = arti.titulo
        if (arti.imgPrincipal) {
          item.querySelector('.imagen img').src = comun.urlBaseApi + arti.imgPrincipal
          item.querySelector('.imagen img').srcset = comun.obtenerSrcset(comun.urlBaseApi + arti.imgPrincipal)
          item.querySelector('.imagen img').alt = arti.nombre
        }
        try {
          // Cambia comillas dobles por simples dentro de enlaces. Convierte <a href="#"> en <a href='#'>
          const enlaces = arti.entradilla.matchAll(/<a\s[^<]*>/g) // Busca enlaces
          let enlaceNuevo
          for (const enlace of enlaces) {
            enlaceNuevo = enlace[0].replace(/\"/g, "'") // Cambia comillas
            arti.entradilla = arti.entradilla.replace(enlace[0], enlaceNuevo) // Reemplaza enlace en el contenido
          }
          //
          let datosEnIntro = JSON.parse(arti.entradilla)
          item.querySelector('.extracto').innerHTML = datosEnIntro.intro
        } catch (e) {
          item.querySelector('.extracto').innerHTML = ''
        }
        const idiomaCat = {
          es: 'categoria',
          en: 'category',
          ca: 'categoria',
          fr: 'categorie',
          pt: 'categoria'
        }
        const enlaces = item.querySelectorAll('.enlace')
        const conIdioma = comun.setIdiomas.includes(document.location.pathname.split('/')[1]) // Hay idioma en URL
        let cat = arti2cat[arti.tituloUrl] ? arti2cat[arti.tituloUrl] : arti.tituloUrl
        for (const enlace of enlaces) {
          if (conIdioma) { // Si hay idioma en URL lo agrega a los enlaces
            enlace.href = `/${isoIdioma}/blog/${idiomaCat[isoIdioma]}/${cat}`
          } else {
            enlace.href = `/blog/${idiomaCat[isoIdioma]}/${cat}`
          }
        }
        // Botón compra
        const idiomaLibro = {
          es: 'libro',
          en: 'book',
          ca: 'llibre',
          fr: 'livre',
          pt: 'livro'
        }
        if (conIdioma) { // Si hay idioma en URL
          item.querySelector('.boton.compra').href = `/${isoIdioma}/${idiomaLibro[isoIdioma]}/${arti.tituloUrl}`
        } else {
          item.querySelector('.boton.compra').href = `/${idiomaLibro[isoIdioma]}/${arti.tituloUrl}`
        }
        //
        contenedor.appendChild(item) // Agrega plantilla al contenedor
        item.classList.remove('plantilla') // y la hace visible
      })
    }
  }
}
